import React from 'react';
import { colors, fonts, space } from '../tokens';

/**
 * FAQCard – einheitliche FAQ-Karte (Frage + Antwort).
 * Höhe & Padding fix → alle 6 FAQs sind visuell identisch behandelt.
 */
export const FAQCard = ({ question, answer }) => (
  <div
    style={{
      padding: `${space.sm + space.xs}px ${space.sm + space.xs}px`,
      background: colors.bgCard,
      borderRadius: '10px',
      border: `1px solid ${colors.border}`,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      minHeight: '148px',
      maxHeight: '148px',
    }}
  >
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '7px', marginBottom: `${space.sm - 2}px`, flexShrink: 0 }}>
      <div
        style={{
          width: '20px',
          height: '20px',
          background: 'rgba(224,112,0,0.1)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginTop: '2px',
        }}
      >
        <span style={{ fontFamily: fonts.display, fontSize: '9px', fontWeight: 700, color: colors.orange }}>?</span>
      </div>
      <h3 style={{ fontFamily: fonts.display, fontSize: '10px', fontWeight: 700, color: colors.navy, lineHeight: 1.3 }}>{question}</h3>
    </div>
    <p
      className="proposal-body"
      style={{
        fontSize: '9px',
        lineHeight: 1.55,
        color: colors.slateMid,
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: 5,
        WebkitBoxOrient: 'vertical',
      }}
    >
      {answer}
    </p>
  </div>
);
